module.exports = __webpack_public_path__ + "img/one-green-light.d1798dea.svg";